export default __webpack_public_path__ + "static/media/data.1a9767d4.png";